import { library } from "@fortawesome/fontawesome-svg-core";

// Solid icons (individual imports instead of full fas pack)
import {
    faMicrophone,
    faBell as faBellSolid,
    faEnvelope as faEnvelopeSolid,
    faChevronLeft as faChevronLeftSolid,
    faChevronRight as faChevronRightSolid,
    faChevronDown as faChevronDownSolid,
    faPlus,
    faMinus,
    faCheck as faCheckSolid,
    faArrowUpFromBracket,
    faXmark as faXmarkSolid,
    faSpinner,
    faHourglassEnd,
    faCircle as faCircleSolid,
    faBadgeCheck,
    faFileCsv,
    faFileCode,
    faHeart,
    faUserPlus,
    faSparkles as faSparklesSolid,
    faSealQuestion,
    faPaperPlaneTop,
    faDungeon,
    faCampfire,
    faCopy as faCopySolid,
    faAxeBattle,
    faDiceD8,
    faFireFlameCurved,
    faWater,
    faComments as faCommentsSolid,
    faPlay as faPlaySolid,
    faLightbulb as faLightbulbSolid,
    faLock as faLockSolid,
    faVolumeHigh as faVolumeHighSolid,
    faCircleCheck as faCircleCheckSolid,
    faUsers as faUsersSolid,
    faHourglassHalf as faHourglassHalfSolid,
    faPenFancy as faPenFancySolid,
    faCoins as faCoinsSolid,
    faCirclePlay as faCirclePlaySolid,
    faCircleQuestion as faCircleQuestionSolid,
    faWandMagicSparkles as faWandMagicSparklesSolid,
    faClock as faClockSolid,
    faMap as faMapSolid,
    faDiceD20 as faDiceD20Solid,
    faHashtag as faHashtagSolid,
    faTrash as faTrashSolid,
    faFaceSmile as faFaceSmileSolid,
    faDragon as faDragonSolid,
    faScroll as faScrollSolid,
    faGear as faGearSolid,
    faBookOpen as faBookOpenSolid,
    faArrowRight as faArrowRightSolid,
    faPause as faPauseSolid,
    faAlignLeft as faAlignLeftSolid,
    faBackwardStep as faBackwardStepSolid,
    faBed as faBedSolid,
    faBellSlash as faBellSlashSolid,
    faBolt as faBoltSolid,
    faBrain as faBrainSolid,
    faBullseye as faBullseyeSolid,
    faCircleExclamation as faCircleExclamationSolid,
    faCloudArrowUp as faCloudArrowUpSolid,
    faCompass as faCompassSolid,
    faCrosshairs as faCrosshairsSolid,
    faCrown as faCrownSolid,
    faDice as faDiceSolid,
    faDownload as faDownloadSolid,
    faDumbbell as faDumbbellSolid,
    faPenToSquare as faPenToSquareSolid,
    faTriangleExclamation as faTriangleExclamationSolid,
    faArrowUpRightFromSquare as faArrowUpRightFromSquareSolid,
    faFileAudio as faFileAudioSolid,
    faFlag as faFlagSolid,
    faFolder as faFolderSolid,
    faFolderOpen as faFolderOpenSolid,
    faForwardStep as faForwardStepSolid,
    faGreaterThanEqual as faGreaterThanEqualSolid,
    faGripVertical as faGripVerticalSolid,
    faHammer as faHammerSolid,
    faHeadphones as faHeadphonesSolid,
    faPersonHiking as faPersonHikingSolid,
    faImage as faImageSolid,
    faInbox as faInboxSolid,
    faCircleInfo as faCircleInfoSolid,
    faKey as faKeySolid,
    faLessThanEqual as faLessThanEqualSolid,
    faList as faListSolid,
    faLocationDot as faLocationDotSolid,
    faMedal as faMedalSolid,
    faMicrophoneSlash as faMicrophoneSlashSolid,
    faPencil as faPencilSolid,
    faRotateRight as faRotateRightSolid,
    faRepeat as faRepeatSolid,
    faRocket as faRocketSolid,
    faRuler as faRulerSolid,
    faPersonRunning as faPersonRunningSolid,
    faMagnifyingGlass as faMagnifyingGlassSolid,
    faServer as faServerSolid,
    faShareNodes as faShareNodesSolid,
    faShieldHalved as faShieldHalvedSolid,
    faRightToBracket as faRightToBracketSolid,
    faStore as faStoreSolid,
    faSun as faSunSolid,
    faTag as faTagSolid,
    faThumbsDown as faThumbsDownSolid,
    faThumbsUp as faThumbsUpSolid,
    faThumbtack as faThumbtackSolid,
    faTrophy as faTrophySolid,
    faUpload as faUploadSolid,
    faUserShield as faUserShieldSolid,
    faUsersSlash as faUsersSlashSolid,
    faVolumeLow as faVolumeLowSolid,
    faVolumeXmark as faVolumeXmarkSolid,
    faCirclePlus as faCirclePlusSolid,
    faStar as faStarSolid,
    faEllipsisVertical as faEllipsisVerticalSolid,
    faEye as faEyeSolid,
    faEyeSlash as faEyeSlashSolid,
    faEyeEvil as faEyeEvilSolid,
    faPen as faPenSolid,
    faHandHoldingMedical as faHandHoldingMedicalSolid,
    faMousePointer as faMousePointerSolid,
    faHand as faHandSolid,
    faSquare as faSquareSolid,
    faDrawPolygon as faDrawPolygonSolid,
    faPaintbrush as faPaintbrushSolid,
    faEraser as faEraserSolid,
    faFont as faFontSolid,
    faLayerGroup as faLayerGroupSolid,
    faClockRotateLeft as faClockRotateLeftSolid,
    faRotateLeft as faRotateLeftSolid,
    faFloppyDisk as faFloppyDiskSolid,
    faCompress as faCompressSolid,
    faLockOpen as faLockOpenSolid,
    faChevronUp as faChevronUpSolid,
    faUser as faUserSolid,
    faBorderAll as faBorderAllSolid,
    faFillDrip as faFillDripSolid,
    faEllipsis as faEllipsisSolid,
    faBars as faBarsSolid,
    faBug as faBugSolid,
    faMountain as faMountainSolid,
    faPrint as faPrintSolid,
    faQrcode as faQrcodeSolid,
    faArrowLeft as faArrowLeftSolid,
    faGripLines as faGripLinesSolid,
    faCouch as faCouchSolid,
    faDoorOpen as faDoorOpenSolid,
    faSkullCrossbones as faSkullCrossbonesSolid,
    faTable as faTableSolid,
    faChair as faChairSolid,
    faBox as faBoxSolid,
    faOilCan as faOilCanSolid,
    faBoxOpen as faBoxOpenSolid,
    faPlaceOfWorship as faPlaceOfWorshipSolid,
    faCubesStacked as faCubesStackedSolid,
    faStairs as faStairsSolid,
    faBone as faBoneSolid,
    faToggleOn as faToggleOnSolid,
    faCube as faCubeSolid,
    faTimes as faTimesSolid,
    faSave as faSaveSolid,
} from '@fortawesome/pro-solid-svg-icons';

// Regular icons
import {
    faBlockQuestion,
    faTrashXmark,
    faCirclePlus,
    faCircle,
    faSword,
    faTriangleExclamation,
    faShield,
    faBookMedical,
    faBookHeart,
    faXmark,
    faFileSlash,
    faLink,
    faCircleInfo,
    faEye,
    faEyeSlash,
    faEnvelope,
    faDiceD20,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faScrollOld,
    faBars,
    faPawClaws,
    faFire,
    faPaperPlane,
    faPenFancy,
    faCirclePlay,
    faPlay,
    faCirclePause,
    faHeart as faHeartOutline,
    faHourglassClock,
    faMagnifyingGlass,
    faPaintBrush,
    faUserCircle,
    faRectangleHistory,
    faBookSparkles,
    faRightFromBracket,
    faTrashCan,
    faCommentExclamation,
    faCloudUpload,
    faSparkle,
    faTableList,
    faBell,
    faDragon,
    faCode,
    faComment,
    faKeyboard,
    faFolderPlus,
    faMap,
    faFolders,
} from '@fortawesome/pro-regular-svg-icons';

// Duotone icons
import {
    faCheck,
    faBan,
    faPenToSquare,
    faBooks,
    faFlask,
    faSack,
    faBeerMugEmpty,
    faShieldHalved,
    faCodeFork,
    faCopy,
    faShare,
    faCauldron,
    faComments,
    faSparkles,
    faCoinVertical,
    faCoins,
    faMicrochipAi,
    faHammerCrash,
    faFeatherPointed,
    faChartColumn,
    faMountain,
    faPenPaintbrush,
    faBracketsCurly,
    faWandMagicSparkles,
    faBookOpen,
    faUsers,
    faChartLine,
    faBowArrow,
    faHandHoldingMedical,
    faExplosion,
    faGem,
    faMandolin,
    faHandPointUp,
    faShieldCheck,
    faMusic,
    faWaveformLines,
    faPalette,
    faDungeon as faDungeonDuotone,
} from '@fortawesome/pro-duotone-svg-icons';

// Brand icons
import {
    faDiscord,
    faFacebook,
    faTwitch,
    faTrello,
    faInstagram,
    faXTwitter,
    faFacebookF,
} from '@fortawesome/free-brands-svg-icons';

// Free solid icons
import { faHatWizard } from '@fortawesome/free-solid-svg-icons';

// Register all icons with the library
library.add(
    // Solid
    faMicrophone,
    faBellSolid,
    faEnvelopeSolid,
    faChevronLeftSolid,
    faChevronRightSolid,
    faChevronDownSolid,
    faPlus,
    faMinus,
    faCheckSolid,
    faArrowUpFromBracket,
    faXmarkSolid,
    faSpinner,
    faHourglassEnd,
    faCircleSolid,
    faBadgeCheck,
    faFileCsv,
    faFileCode,
    faHeart,
    faUserPlus,
    faSparklesSolid,
    faSealQuestion,
    faPaperPlaneTop,
    faDungeon,
    faCampfire,
    faCopySolid,
    faAxeBattle,
    faDiceD8,
    faFireFlameCurved,
    faWater,
    faCommentsSolid,
    faPlaySolid,
    faLightbulbSolid,
    faLockSolid,
    faVolumeHighSolid,
    faCircleCheckSolid,
    faUsersSolid,
    faHourglassHalfSolid,
    faPenFancySolid,
    faCoinsSolid,
    faCirclePlaySolid,
    faCircleQuestionSolid,
    faWandMagicSparklesSolid,
    faClockSolid,
    faMapSolid,
    faDiceD20Solid,
    faHashtagSolid,
    faTrashSolid,
    faFaceSmileSolid,
    faDragonSolid,
    faScrollSolid,
    faGearSolid,
    faBookOpenSolid,
    faArrowRightSolid,
    faPauseSolid,
    faAlignLeftSolid,
    faBackwardStepSolid,
    faBedSolid,
    faBellSlashSolid,
    faBoltSolid,
    faBrainSolid,
    faBullseyeSolid,
    faCircleExclamationSolid,
    faCloudArrowUpSolid,
    faCompassSolid,
    faCrosshairsSolid,
    faCrownSolid,
    faDiceSolid,
    faDownloadSolid,
    faDumbbellSolid,
    faPenToSquareSolid,
    faTriangleExclamationSolid,
    faArrowUpRightFromSquareSolid,
    faFileAudioSolid,
    faFlagSolid,
    faFolderSolid,
    faFolderOpenSolid,
    faForwardStepSolid,
    faGreaterThanEqualSolid,
    faGripVerticalSolid,
    faHammerSolid,
    faHeadphonesSolid,
    faPersonHikingSolid,
    faImageSolid,
    faInboxSolid,
    faCircleInfoSolid,
    faKeySolid,
    faLessThanEqualSolid,
    faListSolid,
    faLocationDotSolid,
    faMedalSolid,
    faMicrophoneSlashSolid,
    faPencilSolid,
    faRotateRightSolid,
    faRepeatSolid,
    faRocketSolid,
    faRulerSolid,
    faPersonRunningSolid,
    faMagnifyingGlassSolid,
    faServerSolid,
    faShareNodesSolid,
    faShieldHalvedSolid,
    faRightToBracketSolid,
    faStoreSolid,
    faSunSolid,
    faTagSolid,
    faThumbsDownSolid,
    faThumbsUpSolid,
    faThumbtackSolid,
    faTrophySolid,
    faUploadSolid,
    faUserShieldSolid,
    faUsersSlashSolid,
    faVolumeLowSolid,
    faVolumeXmarkSolid,
    faCirclePlusSolid,
    faStarSolid,
    faEllipsisVerticalSolid,
    faEyeSolid,
    faEyeSlashSolid,
    faEyeEvilSolid,
    faPenSolid,
    faHandHoldingMedicalSolid,
    faMousePointerSolid,
    faHandSolid,
    faSquareSolid,
    faDrawPolygonSolid,
    faPaintbrushSolid,
    faEraserSolid,
    faFontSolid,
    faLayerGroupSolid,
    faClockRotateLeftSolid,
    faRotateLeftSolid,
    faFloppyDiskSolid,
    faCompressSolid,
    faLockOpenSolid,
    faChevronUpSolid,
    faUserSolid,
    faBorderAllSolid,
    faFillDripSolid,
    faEllipsisSolid,
    faBarsSolid,
    faBugSolid,
    faMountainSolid,
    faPrintSolid,
    faQrcodeSolid,
    faArrowLeftSolid,
    faGripLinesSolid,
    faCouchSolid,
    faDoorOpenSolid,
    faSkullCrossbonesSolid,
    faTableSolid,
    faChairSolid,
    faBoxSolid,
    faOilCanSolid,
    faBoxOpenSolid,
    faPlaceOfWorshipSolid,
    faCubesStackedSolid,
    faStairsSolid,
    faBoneSolid,
    faToggleOnSolid,
    faCubeSolid,
    faTimesSolid,
    faSaveSolid,

    // Regular
    faBlockQuestion,
    faTrashXmark,
    faCirclePlus,
    faCircle,
    faSword,
    faTriangleExclamation,
    faShield,
    faBookMedical,
    faBookHeart,
    faXmark,
    faFileSlash,
    faLink,
    faCircleInfo,
    faEye,
    faEyeSlash,
    faEnvelope,
    faDiceD20,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faScrollOld,
    faBars,
    faPawClaws,
    faFire,
    faPaperPlane,
    faPenFancy,
    faCirclePlay,
    faPlay,
    faCirclePause,
    faHeartOutline,
    faHourglassClock,
    faMagnifyingGlass,
    faPaintBrush,
    faUserCircle,
    faRectangleHistory,
    faBookSparkles,
    faRightFromBracket,
    faTrashCan,
    faCommentExclamation,
    faCloudUpload,
    faSparkle,
    faTableList,
    faBell,
    faDragon,
    faCode,
    faComment,
    faKeyboard,
    faFolderPlus,
    faMap,
    faFolders,

    // Duotone
    faCheck,
    faBan,
    faPenToSquare,
    faBooks,
    faFlask,
    faSack,
    faBeerMugEmpty,
    faShieldHalved,
    faCodeFork,
    faCopy,
    faShare,
    faCauldron,
    faComments,
    faSparkles,
    faCoinVertical,
    faCoins,
    faMicrochipAi,
    faHammerCrash,
    faFeatherPointed,
    faChartColumn,
    faMountain,
    faPenPaintbrush,
    faBracketsCurly,
    faWandMagicSparkles,
    faBookOpen,
    faUsers,
    faChartLine,
    faBowArrow,
    faHandHoldingMedical,
    faExplosion,
    faGem,
    faMandolin,
    faHandPointUp,
    faShieldCheck,
    faMusic,
    faWaveformLines,
    faPalette,
    faDungeonDuotone,

    // Brands
    faDiscord,
    faFacebook,
    faTwitch,
    faTrello,
    faInstagram,
    faXTwitter,
    faFacebookF,

    // Free solid
    faHatWizard,
);
